import React from 'react';
import { Heart } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Brand */}
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
              <span className="text-xl">✍️</span>
            </div>
            <span className="text-lg font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              V-Blog
            </span>
          </div>

          {/* Policy Links */}
          <div className="flex items-center gap-4 text-sm text-gray-600">
            <Link to="/policies/privacy-policy" className="hover:text-blue-600 transition-colors">
              Chính sách bảo mật
            </Link>
            <span className="text-gray-300">|</span>
            <Link to="/policies/term-of-service" className="hover:text-blue-600 transition-colors">
              Điều khoản sử dụng
            </Link>
          </div>

          {/* Copyright & Credits */}
          <div className="flex flex-col md:flex-row items-center gap-3 md:gap-6 text-sm text-gray-600">
            <p className="text-center">
              © {currentYear} V-Blog. Bảo lưu mọi quyền.
            </p>
            <p className="flex items-center gap-1">
              Được tạo với <Heart className="h-4 w-4 text-red-500 fill-red-500" /> bởi Học Nhé
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};